import type { ServiceInterval } from '@chukua/common';

const number = new Intl.NumberFormat('en-KE');

/** "20,000 km · 180 days · 500 h", or a dash when the set is empty (a class line that defers to its item shows the item's, never this). */
export function formatInterval(interval: ServiceInterval): string {
  const parts = [
    interval.intervalKm != null && `${number.format(interval.intervalKm)} km`,
    interval.intervalDays != null && `${number.format(interval.intervalDays)} days`,
    interval.intervalHours != null && `${number.format(interval.intervalHours)} h`,
  ].filter(Boolean);
  return parts.length > 0 ? parts.join(' · ') : '—';
}
